import React from 'react'
import { connect } from 'react-redux'

import InputElement from '../../utils/input'

const mapStateToProps = (state, ownProps) => {
    const answer = state.answers.find(a => a.groupQuestionId === ownProps.groupQuestionId && a.installationId === ownProps.installation.id)
    let answerValue = null
    if (answer) {
        answerValue = state.answerValues.find(av => av.answerId === answer.id)
    }
    return {
        answer,
        answerValue
    }
}

const OptionSelectQuestion = ({ question, answer, answerValue, installation }) => {
    const renderNotes = () => {
        if (answerValue?._computed.statusValue === 'REJECTED') {
            return (
                <div className="rejected-notes">
                    <span className="error-label"> Error</span>
                    <p className="notes">
                        {answerValue.notes}
                    </p>
                </div>
            )
        }
        return null
    }

    let inputId = `answer_${answer?.id}`
    if (answerValue) {
        inputId = inputId + '_' + answerValue.id
    }
    return (
        <>
            <InputElement
                type="select"
                id={inputId}
                options={question.options}
                label={question.label}
                infoIcon={question?.instructions ? 'circle-info' : null}
                instructions={question?.instructions}
                default={answerValue?.textValue}
                extraClass={`with-status ${answer?._computed.statusValue.toLowerCase()}`}
                readOnly={installation?._computed.statusDisplay === 'Submitted' ? true : false} />
            {renderNotes()}
        </>
    )
}

export default connect(mapStateToProps)(OptionSelectQuestion)
